import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DespatchOrderService = {
  async getDespatchOrderCode(code) {
    const requestScreenData = {
      url: "api/PickingSlip",
      top: "1",
      filter: `SalesOrderCode eq ${code}`,
      expand: "SalesOrderType,SalesRepresentative,Branch,Division,Customer"
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/PickingSlipDetail";
    return ApiService.createDataSource(url, params);
  },

  async updateDespatchOrder(payload, orderId) {
    var url = `api/Save_PickingSlip(${orderId})`;
    // var url = `api/Save_PickingSlip`;
    return await ApiService.put(url, payload);
  },

  async saveDespatchOrder(payload) {
    var url = `api/Save_PickingSlip`;
    // var url = `api/Save_PickingSlip`;
    return await ApiService.post(url, payload);
  },

  getPickingSlipProductBatch(filter, params) {
    const requestScreenData = {
      url: "api/PickingSlipProductBatch",
      filter: filter,
    };

    if (params) {
      if (params.orderby) {
        requestScreenData.orderby = params.orderby;
      }
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return ApiService.oDataGet(requestScreenData);
  },


  async getDespatchOrderDetailsByCode(code, params) {
    const requestScreenData = {
      url: "api/PickingSlipDetail",
      filter: `(SalesOrderCode eq ${code}) and ((Status eq 'A') or (Status eq 'I'))`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },


};



export { DespatchOrderService };
